import Vue from 'vue'
import './axios.js'
import localStrage from 'vue-localstorage'
Vue.use(localStrage,{
	name:'localStrage',
	bind:true
});